import { render, staticRenderFns } from "./ScanQuery.vue?vue&type=template&id=2d642e04&scoped=true&"
import script from "./ScanQuery.vue?vue&type=script&lang=js&"
export * from "./ScanQuery.vue?vue&type=script&lang=js&"
import style0 from "./ScanQuery.vue?vue&type=style&index=0&id=2d642e04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d642e04",
  null
  
)

export default component.exports